import { configureStore } from '@reduxjs/toolkit'
import authSlice from '../pages/auth/authSlice'
import BranchSlice from '../pages/ManageBranches/BranchSlice'
import BranchUserSlice from '../pages/ManageBranches/ManageBranchUser/BranchUserSlice'
import StaffSlice from '../pages/ManageStaff/StaffSlice'
import ClassesSlice from '../pages/MainHub/Classes/ClassesSlice'
import SectionSlice from '../pages/MainHub/Sections/SectionSlice'
import GlobalSlice from './GlobalSlice'
import GroupsLedgersSlice from '../pages/MainHub/GroupsLedgers/GroupsLedgersSlice'
import institutionUserSlice from '../pages/ManageInstitutionUsers/institutionUserSlice'
import AcademicYearSlice from '../pages/Years/ManageAcademicYears/AcademicYearSlice'
import FeeTermSlice from '../pages/FeeManagement/FeeTerm/FeeTermSlice'
import FeeStructureSlice from '../pages/FeeManagement/FeeStructure/FeeStructureSlice'
import AssociationSlice from '../pages/ManageAssociation/AssociationSlice'
import commonSlice from './commonSlice'
import studentSlice from '../pages/StudentMaster/Directory/studentSlice'
// eslint-disable-next-line max-len
import  idSlice from "../pages/StudentMaster/Attendance/ModifyAttendance/StudentAttendanceSlice" // your Redux Toolkit root reducer
import attendanceSlice from '../pages/StudentMaster/Attendance/attendanceSlice'

import { persistReducer, persistStore } from 'redux-persist';
import storage from 'localforage'; // or any other storage library
import FinancialYearSlice from '../pages/Years/ManageFinancialYear/FinancialYearSlice'
import InventoryListSlice from '../pages/InventoryMaster/InventoryList/InventoryListSlice'
import PurchaseOrderListSlice from '../pages/InventoryMaster/PurchaseOrder/PurchaseOrderListSlice'
import ViewGrnSlice from '../pages/InventoryMaster/PurchaseOrder/Components/ViewGrn/ViewGrnSlice'
import PayrollSlice from '../pages/EmployeeMaster/Payroll/PayrollSlice'
import PayslipSlice from '../pages/Profile/Payslips/PayslipSlice'
import InvoiceListSlice from '../pages/StudentMaster/InvoicesList/InvoiceListSlice'
import CollectFeeListSlice from '../pages/StudentMaster/CollectFee/collectfeeSlice'
import ClassDiarySlice from '../pages/NoticeBoard/Classroom/ClassRoomSlice'
import BroadcastsSlice from '../pages/NoticeBoard/Broadcasts/BroadcastsSlice'

const persistConfig = {
    key: 'root', // key for the storage
    storage, // storage engine to use
};
const persistedReducer = persistReducer(persistConfig, idSlice);

export const store = configureStore({
    reducer: {
        auth: authSlice,
        BranchSlice:BranchSlice,
        BranchUserSlice: BranchUserSlice,
        StaffSlice : StaffSlice,
        ClassesSlice : ClassesSlice,
        Section:SectionSlice,
        GlobalData:GlobalSlice,
        GroupsLedgersSlice : GroupsLedgersSlice,
        InstitutionUserSlice: institutionUserSlice,
        AcademicYearSlice: AcademicYearSlice,
        FeeTermSlice : FeeTermSlice,
        FeeStructureSlice : FeeStructureSlice,
        Association:AssociationSlice,
        CommonData:commonSlice,
        StudentsDirectorySlice:studentSlice,
        StudentsIdSlice:persistedReducer,
        attendanceSlice:attendanceSlice,
        FinancialYearSlice : FinancialYearSlice,
        InventoryListSlice : InventoryListSlice,
        purchaseOrderListSlice : PurchaseOrderListSlice,
        viewGrnSlice : ViewGrnSlice,
        payrollSlice: PayrollSlice,
        PayslipListSlice : PayslipSlice,
        ManageInvoiceList : InvoiceListSlice,
        CollectFeeList : CollectFeeListSlice,
        ClassDiarySlice : ClassDiarySlice,
        BroadcastsSlice : BroadcastsSlice,

    },
})


export const persistor = persistStore(store);
